export default {"src":"/_next/static/media/twitter.90a853ef.ico","height":278,"width":308,"blurWidth":0,"blurHeight":0};